import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {CookieService} from 'ngx-cookie';
import {Observable} from 'rxjs';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class CommissionService {
    readonly baseURL = DDP_ENV.patientUrl;

    constructor(private _http: Http, private cookieService: CookieService) {}

    getPhysicianCommission(physicianId) {
        console.log('Inside get physician');
        // return this._http.get('http://localhost:5002/app/physician/commission/'+physicianId, this.buildHeaders());
        return this._http.get(this.baseURL + '/app/physician/commission/'+physicianId, this.buildHeaders());
    }

    saveCommission(payload): Observable<any> {
        return this._http.post(this.baseURL + '/app/physician/commission/add', payload, this.buildHeaders())
        // return this._http.post('http://localhost:5002/app/physician/commission/add', payload, this.buildHeaders())
            .map((res: Response) => {
                return res.json(); });
    }

    /* Construct a common header */
    private buildHeaders(): any {
        const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
        return new RequestOptions({ headers: headers });
    }
}
